import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getAgents, getAgentsForSalesAndRegionalRoles } from '@/api/agents';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { isRegionalManager, isSalesExecutiveManager, isZonalManager } from '@/common';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.isSalesExe = false;
    this.isRegional = false;
    this.isZonal = false;
    this.listQuery = {
      page: 1,
      limit: 10,
      name: undefined,
      enabled: true,
      code: undefined,
      sort: 'id,ASC',
      filter: {
        name: '$contL',
        enabled: '$eq',
        code: '$startsL'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    if (AdminModule.roles.length > 0) {
      if (AdminModule.roles.includes('Sales Executive')) {
        this.isSalesExe = true;
      }
      if (AdminModule.roles.includes('Regional Manager')) {
        this.isRegional = true;
      }
      if (AdminModule.roles.includes('Zonal Manager')) {
        this.isZonal = true;
      }
    }
    this.getList();
  }
  isSalesManager() {
    return isSalesExecutiveManager();
  }
  isRegionalManager() {
    return isRegionalManager();
  }
  isZonalManager() {
    return isZonalManager();
  }
  async getList() {
    try {
      this.listLoading = true;
      let data;
      if (this.isSalesExe || this.isRegional || this.isZonal) {
        this.listQuery.applyBranchIdFilter = true;
        data = await getAgentsForSalesAndRegionalRoles(getQuery(this.listQuery));
      } else {
        data = await getAgents(getQuery(this.listQuery));
      }
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  async handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['ID', 'Name', 'Code'];
    const filterVal = ['id', 'name', 'code'];
    const agentFilter = Object.assign({}, this.listQuery);
    delete agentFilter.limit;
    delete agentFilter.page;
    const dealers = await getAgents(getQuery(agentFilter));
    const data = formatJson(filterVal, dealers);
    exportJson2Excel(tHeader, data, this.$tc('route.dealerManagement.agent.title'));
    this.downloadLoading = false;
  }
};
default_1 = __decorate([Component({
  name: 'AgentList',
  components: {
    Pagination,
    Enabled
  }
})], default_1);
export default default_1;